/**
 * Puntos de recogida API
 * Puntos de recogida API.
 *
 * The version of the OpenAPI document: 1.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GestorPtoRecogidaFilterDTO } from './gestorPtoRecogidaFilterDTO';
import { FacturaEstadoDTO } from './facturaEstadoDTO';
import { IdEntityFilterDTO } from './idEntityFilterDTO';


export interface FacturaPtoRecogidaFilterDTO { 
    id?: number;
    gestorPtoRecogida?: GestorPtoRecogidaFilterDTO;
    numeroFactura?: string;
    numeroFacturaGestor?: string;
    fechaAutofactura?: string;
    fechaFactura?: string;
    estado?: IdEntityFilterDTO;
    origen?: FacturaPtoRecogidaFilterDTO.OrigenEnum;
}
export namespace FacturaPtoRecogidaFilterDTO {
    export type OrigenEnum = 'POSEEDORES' | 'PUNTOSRECOGIDA' | 'SDDRCC' | 'SDDRCA' | 'ADHERIDO' | 'GESTORESACUERDO';
    export const OrigenEnum = {
        Poseedores: 'POSEEDORES' as OrigenEnum,
        Puntosrecogida: 'PUNTOSRECOGIDA' as OrigenEnum,
        Sddrcc: 'SDDRCC' as OrigenEnum,
        Sddrca: 'SDDRCA' as OrigenEnum,
        Adherido: 'ADHERIDO' as OrigenEnum,
        Gestoresacuerdo: 'GESTORESACUERDO' as OrigenEnum
    };
}


